import React from 'react';
import CouponSection from '../forms/CouponSection';

const PlanSelectionModal = ({
  show,
  onClose,
  plans,
  discountedPlans,
  selectedPlan,
  onPlanSelect,
  translations,
  couponCode,
  setCouponCode,
  appliedCoupon,
  couponLoading,
  couponMessage,
  couponMessageType,
  onApplyCoupon,
  onRemoveCoupon,
  onPayNow,
  plansLoading,
  paymentLoading,
  couponDisabled,
}) => {
  React.useEffect(() => {
    if (show && window.posthog) {
      // Temporarily disable PostHog during modal
      const originalCapture = window.posthog.capture;
      window.posthog.capture = function(...args) {
        // Queue events but don't block
        setTimeout(() => originalCapture.apply(this, args), 100);
      };
      
      return () => {
        // Restore PostHog capture
        if (window.posthog) {
          window.posthog.capture = originalCapture;
        }
      };
    }
  }, [show]);

  if (!show) return null;

  const displayPlans = discountedPlans.length > 0 ? discountedPlans : plans;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '800px',
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '32px',
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
          zIndex: 1050,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              border: 'none',
              background: 'transparent',
              fontSize: '24px',
              lineHeight: '1',
              color: 'gray',
              cursor: 'pointer',
              padding: 0,
              marginBottom: '1px',
            }}
          >
            ×
          </button>
        </div>

        <h2 className='plan_main_heading'>{translations.selectPlan}</h2>

        <div style={{ marginBottom: '15px' }}>
          {plansLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #f3f4f6',
                  borderTop: '4px solid #2563eb',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                justifyContent: 'center',
              }}
            >
              {displayPlans.map((plan) => (
                <div
                  key={plan.id}
                  onClick={() => onPlanSelect(plan)}
                  style={{
                    width: 'calc(50% - 8px)',
                    minWidth: '280px',
                    border: `2px solid ${selectedPlan?.id === plan.id ? '#2563eb' : '#e5e7eb'}`,
                    borderRadius: '10px',
                    padding: '20px',
                    backgroundColor: 'rgb(249, 250, 251)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: '16px',
                    }}
                  >
                    <h3 className='plan_name'>{plan.name}</h3>
                    <div style={{ textAlign: 'right' }}>
                      {plan.discounted && plan.originalPrice > plan.price ? (
                        <>
                          <div className='plan_price'>
                            {plan.currencySymbol + plan.price}
                            {plan.price === 0 && <span className='plan_free'>FREE</span>}
                            <span
                              style={{
                                fontSize: '14px',
                                color: '#6b7280',
                                textDecoration: 'line-through',
                                marginLeft: '4px',
                              }}
                              className='plan_price'
                            >
                              {plan.currencySymbol + plan.originalPrice}
                            </span>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            fontSize: '18px',
                            fontWeight: '700',
                            color: 'rgb(37, 99, 235)',
                          }}
                          className='plan_price'
                        >
                          {plan.currencySymbol + plan.price}
                        </div>
                      )}
                    </div>
                  </div>

                  <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                    {plan.features.map((feature, i) => (
                      <li key={i} className='plan_features'>
                        <span
                          style={{
                            color: '#10b981',
                            marginRight: '8px',
                            flexShrink: 0,
                          }}
                        >
                          ✓
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>

        <CouponSection
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          appliedCoupon={appliedCoupon}
          couponLoading={couponLoading}
          couponMessage={couponMessage}
          couponMessageType={couponMessageType}
          onApplyCoupon={onApplyCoupon}
          onRemoveCoupon={onRemoveCoupon}
          translations={translations}
          selectedPlan={selectedPlan}
          couponDisabled={couponDisabled}
        />

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={onPayNow}
            disabled={!selectedPlan || plansLoading || paymentLoading}
            style={{
              padding: '10px 20px',
              backgroundColor: !selectedPlan || plansLoading || paymentLoading ? '#9ca3af' : '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: !selectedPlan || paymentLoading ? 'not-allowed' : 'pointer',
              width: '100%',
              maxWidth: '300px',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {paymentLoading && (
              <div
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid transparent',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
            )}
            {paymentLoading ? translations.processing || 'Processing...' : translations.payNow}
          </button>
        </div>

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default PlanSelectionModal;
